<nav class="navbar bottom-border app-header" [class.fixed-top]="settings.theme.navbarIsFixed">
  <div class="d-flex flex-column w-100">
    <div class="d-flex justify-content-start align-items-center top-navbar">
      <div
        class="navbar-text menu-icon transition ml-3 mr-3"
        [ngClass]="{'open': settings.theme.showMenu}"
        (click)="settings.theme.showMenu = !settings.theme.showMenu"
        data-testid="header-show-menu">
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
        <div class="line"></div>
    </div>
      <a class="logo" routerLink="/" (click)="closeSubMenus()" data-testid="header-aladdin">
        <img title="Aladdin" src="assets/img/app/Aladdin-Logo-Horizontal-Small-Color.png" height="45px" width="100px">
      </a>


      <app-test-banner class="flex-grow-1"></app-test-banner>


      <div class="d-flex justify-content-end align-items-center">
        <app-request-queueing-test
          *ngIf="showRequestQueueingTest"
          class="mx-2"
        ></app-request-queueing-test>

        <app-session-timer
          *ngIf="showAccessTokenTimer"
          class="mx-2"
        ></app-session-timer>
        <app-page-user-list></app-page-user-list>
        <div class="user-name mx-1">{{CurrentUserName}}</div>

        <app-application-select class="mx-2" data-testid="header-application-select"></app-application-select>

        <app-user-menu class="mx-1" data-testid="header-user-menu"></app-user-menu>
      </div>

    </div>
  </div>
</nav>


// WEBPACK FOOTER //
// ./src/app/core/components/header/header.component.html